module.exports = __webpack_public_path__ + "img/yjdhn_09.dd98f38d.png";